module.exports = __webpack_public_path__ + "ban.a0d0bd32f7095bb35db4.jpg";


//////////////////
// WEBPACK FOOTER
// /home/federicblack/public_html/GrupoCristalino/src/assets/img/ban.jpg
// module id = ../../../../../src/assets/img/ban.jpg
// module chunks = main